/*/// <reference types="@types/googlemaps" />*/
/// <reference types="@types/google.maps" />

import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, LocationInfo } from 't4core';

@Component({
    selector: 't4-FindLocationDialog',
    templateUrl: 'FindLocationDialog.html',
    styleUrls: ['./FindLocationDialog.css']
})
export class FindLocationDialog extends DialogBase implements OnInit {
    private availableLocations: LocationInfo[] = [];
    public role: string = "Pickup";
    private isOneWay: boolean = false;
    public isDefault: boolean = false;
    public usingFilter = true;

    private defaultLocationId: number = 0;

    public searchResults: LocationInfo[] = [];
    public selectedLocation: LocationInfo;
    private searchLocation: google.maps.LatLng;
    public filteredResults: LocationInfo[] = [];
    private autocompleteInitialized = false;

  @ViewChild("txtSearchBox", { static: false }) public txtLocationSearch: ElementRef;
  @ViewChild("txtInputSearchBox", { static: false }) public txtInputSearch: ElementRef;
  private searchBox: google.maps.places.Autocomplete;

    constructor(public dialogRef: MatDialogRef<FindLocationDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        super("FindLocationDialog");
        if (data.Locations) this.availableLocations = data.Locations;
        if (data.Role) this.role = data.Role;
        if (data.IsOneWay) this.isOneWay = data.IsOneWay;
        if (data.isDefault) this.isDefault = data.isDefault;

        if (data.SelectedLocation) {
            this.defaultLocationId = data.SelectedLocation.Id;
            this.selectLocation(data.SelectedLocation);
            this.filterByLocation(new google.maps.LatLng(this.selectedLocation.Latitude, this.selectedLocation.Longitude));
        } else if (data.SelectedLocationId) {
            this.defaultLocationId = data.SelectedLocation.Id;
            this.Api.get<LocationInfo>("/Location/GetLocationInfo", { id: this.data.SelectedLocationId }).then(x => {
                this.selectLocation(x);
                this.filterByLocation(new google.maps.LatLng(this.selectedLocation.Latitude, this.selectedLocation.Longitude));
            });
        } else if(this.availableLocations.length > 0) {
            // Pre select random location
           var loc = this.availableLocations.sort((a, b) => {
                if (Math.random() < Math.random()) return -1;
                else return 1;
            })[0];

            this.selectLocation(loc);
            this.filterByLocation(new google.maps.LatLng(loc.Latitude, loc.Longitude));
        }
    }

    public async ngOnInit() {
      if (!this.availableLocations || this.availableLocations.length <= 0) {
          this.loading.locations = true;
          await this.Api.get<LocationInfo[]>("/Location/GetAvailableLocations", { isOneway: this.isOneWay, includeService: this.role  == "None" }).then(x => {
            this.availableLocations = x;
              
            if (!this.selectedLocation) {
              // Pre select random location
              var loc = this.availableLocations.sort((a, b) => {
                if (Math.random() < Math.random()) return -1;
                else return 1;
              })[0];

              this.selectLocation(loc);
            }
            this.filterByLocation(new google.maps.LatLng(this.selectedLocation.Latitude, this.selectedLocation.Longitude));
              this.loading.locations = false;
          });
      }

    //var types = "address";
    ////if (!this.Settings.isInAny(['Admin', '[OneWayAdmin'])) {
    //  types = "(regions)";
    ////}
}
  public onSearchFocus() {
    if (this.autocompleteInitialized) return;
    this.autocompleteInitialized = true;
    this.initPlacesAutocomplete();
  }

  private initPlacesAutocomplete() {
    if (!this.isDefault) {
      this.searchBox = new google.maps.places.Autocomplete(this.txtLocationSearch.nativeElement, { componentRestrictions: { country: ['NO', 'SE', 'DK', 'DE', 'IS'] }, types: ['locality', 'neighborhood', 'sublocality'], fields: ['geometry'] });
      this.searchBox.setTypes(["geometry"]);
      this.searchBox.addListener("place_changed", () => {

        //get the place result
        let place: google.maps.places.PlaceResult = this.searchBox.getPlace();

        if (place) {
          this.filterByLocation(place.geometry.location);
          this.selectLocation(this.searchResults[0]);
        }
      });
    }
  }


  //public filterLocationsByName() {
  //  console.log("input name", this.txtNameSearch.nativeElement.value);
  //  this.filteredResults = this.availableLocations.filter(item =>
  //    item.Name.toLowerCase().includes(this.txtNameSearch.nativeElement.value.toLowerCase())
  //  );
  //}

  public locationCodeSearch(input) {
      this.searchResults = this.availableLocations.filter(l => l.LocationCode && l.LocationCode.includes(input) && l.IsDeleted == false)
        .slice(0, 50);
      this.txtLocationSearch.nativeElement.blur();
  }
  public locationInputSearch(input) {

    this.searchResults = (this.availableLocations.filter(l => l.Name?.toLowerCase().includes(input.target.value.toLowerCase()) && l.IsDeleted == false)
      || this.availableLocations.filter(l => l.City?.toLowerCase().includes(input.target.value.toLowerCase()) && l.IsDeleted == false)).slice(0, 50);

    if (this.searchResults.length > 0) {
      const streetResults = this.availableLocations.filter(l => l.Address?.toLowerCase().includes(input.target.value.toLowerCase()) && l.IsDeleted == false)
        .slice(0, 50);

      this.searchResults = [...this.searchResults, ...streetResults];
      
    }
    else {
      this.searchResults = this.availableLocations.filter(l => l.LocationCode?.includes(input.target.value.toString()) && l.IsDeleted == false).slice(0, 50);
    }
    this.txtInputSearch.nativeElement.blur();
  }
    private filterByLocation(latLng: google.maps.LatLng) {
        this.searchLocation = latLng;

      for (var i = 0; i < this.availableLocations.length; i++) {
        this.availableLocations[i].Distance = google.maps.geometry.spherical.computeDistanceBetween(this.searchLocation, new google.maps.LatLng(this.availableLocations[i].Latitude, this.availableLocations[i].Longitude)) / 1000.0;

          //Shows the closets location if logged in as Admin / OneWayAdmin.
          //Otherwise the rental location under 50km would be randomized.
          if (!this.Settings.isInAny(['Admin', '[OneWayAdmin'])) {
            if (this.isOneWay && this.availableLocations[i].Distance < 50) {
              this.availableLocations[i].Distance = 0;
            }
          }

        }

      this.searchResults = this.availableLocations.sort((a, b) => {
            if (a.Distance < b.Distance) return -1;
          if (a.Distance > b.Distance) return 1;
          return 0;
        }).slice(0, 50);
    }

  public selectLocation(location: LocationInfo) {
        if (this.defaultLocationId != location.Id && this.Settings.clientSettings.RentalLocationId &&  location.Id != this.Settings.clientSettings.RentalLocationId) {
            if ((this.role == 'Pickup' && !location.OpenForPickup) || (this.role == 'Return' && !location.OpenForReturn)) return;
        }

      this.selectedLocation = location;
    }

    public static async open(dialog: MatDialog, isPickup: boolean = false, isReturn: boolean = false, locations: LocationInfo[] = [], selectedLocation: LocationInfo = null): Promise<LocationInfo> {
        var role = "None";
        if (isPickup) role = "Pickup";
        if (isReturn) role = "Return";

        var dlg = dialog.open(FindLocationDialog, {
            data: {
                Locations: locations,
                Role: role,
                SelectedLocation: selectedLocation,
                IsOneWay: true
            }
        });

        return await dlg.afterClosed().toPromise();
  }
}
